"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var File =
/*#__PURE__*/
function () {
  function File() {
    _classCallCheck(this, File);

    this.buffer = null;
    this.cursor = 0;
    this.endOfData = 0;
    this.initialSize = 5000;
    this.scaleSize = 5000;
  }

  _createClass(File, [{
    key: "getBuffer",
    value: function getBuffer() {
      var endOfData = this.endOfData;
      this.endOfData = 0;
      return this.buffer.slice(0, endOfData);
    }
  }, {
    key: "openWrite",
    value: function openWrite() {
      this.buffer = Buffer.alloc(this.initialSize);
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return Buffer.isBuffer(this.buffer);
    }
  }, {
    key: "write",
    value: function write(data) {
      if (this.buffer.length - (this.cursor + data.length) <= 0) {
        this.buffer = Buffer.concat([this.buffer, Buffer.alloc(this.scaleSize)]);
      }

      var writedBytes = 0;

      if (Buffer.isBuffer(data)) {
        writedBytes = data.copy(this.buffer, this.cursor);
      } else if (typeof data === 'string') {
        writedBytes = this.buffer.write(data, this.cursor);
      } else {
        throw new Error('Data type if not correct');
      }

      if (this.cursor === this.endOfData) this.endOfData += writedBytes;
      this.cursor += writedBytes;
    }
  }, {
    key: "seek",
    value: function seek(offset) {
      var whence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      switch (whence) {
        case 0:
          this.cursor = offset;
          break;

        case 1:
          this.cursor += offset;
          break;

        case 2:
          this.cursor = this.endOfData + offset;
          break;
      }

      return this.cursor;
    }
  }, {
    key: "close",
    value: function close() {
      this.cursor = 0;
    }
  }, {
    key: "offset",
    get: function get() {
      return this.seek(0, 1);
    }
  }]);

  return File;
}();

exports["default"] = File;